import { StateParams } from 'angular-ui-router';
import { EulaModel } from '../service.tn.eula';

export class EulaController {
    public eula_title?: string;
    public eula_subtitle?: string;
    public preface?: string;
    public eula?: string;
    public eula_web?: string;
    public eula_web_self_hosted?: string;
    public eula_epub?: string;
    public eula_app?: string;
    public eula_desktop?: string;
    public eula_game?: string;
    public eula_broadcast?: string;
    public eula_embedding?: string;
    public eula_server?: string;
    public postface?: string;

    public static $inject = ['$stateParams', 'eula'];

    public constructor($stateParams: StateParams, eula: EulaModel) {
        this.eula_title = eula.eula_title;
        this.eula_subtitle = eula.eula_subtitle;
        this.preface = eula.preface;
        this.eula = eula.eula;

        // Show license types explicitly mentioned, or default to all
        const hasTypes = $stateParams.types.length > 0;
        [
            'web',
            'web_self_hosted',
            'app',
            'epub',
            'desktop',
            'embedding',
            'game',
            'server',
            'broadcast',
        ].forEach((licenseType) => {
            if (!hasTypes || $stateParams.types.includes(licenseType)) {
                this['eula_' + licenseType] = eula['eula_' + licenseType];
            }
        });
    }
}
